import React, { Component } from "react";
import {
    Col,
    Row,
} from "reactstrap";
import Registry from "../../Utils/Registry";

import TYPagination from "../TYPagination";
import OperationsOrdersTable from "./Orders/OrdersTable";
import {NotificationManager} from "react-notifications";


class OperationsOrders extends Component{
    constructor(props){
        super(props);

        this.api = Registry.registered("api");

        this.changePage = this.changePage.bind(this);
        this.onNotify = this.onNotify.bind(this);

        this.state = {
            notify: {show: false, msg: "", type: "success"},
            loading: false,
            orders: [],
            per_page: 8,
            page: 1,
            total_pages: 1,
            isOpen: false,
        };
    }

    loadOrders = (page=1) => {
        let url = "";
        this.setState({
            loading: true,
            orders: []
        });

        if (this.props.orderStatus !== "waiting")
            url = "/orders?is_business=1&per_page="+this.state.per_page+"&page="+page+"&order_by_desc=start_datetime&waiting=0&delivered=" + (this.props.orderStatus === "done" ? "1" : "0");
        else
            url = "/orders?is_business=1&per_page="+this.state.per_page+"&page="+page+"&order_by_desc=available_date_min&status=" + this.props.orderStatus;

        this.api.get(url)
            .then(results => {
                let r = [];
                this.setState({
                    loading: false,
                    orders: results.results,
                    per_page: results.per_page,
                    page: results.page,
                    total_pages: results.total_pages
                });
            })
            .catch(error => {
                this.setState({ loading: false });
            });
    }

    changePage(page){
        this.loadOrders(page);
    }

    onNotify(msg, type="success", timeout=5000){
        switch (type){
            case "info":
                NotificationManager.info(msg);
                break;
            case "success":
                NotificationManager.success(msg);
                break;
            case "warning":
                NotificationManager.warning(msg);
                break;
            case "error":
                NotificationManager.error(msg);
                break;
            default:
                break;
        }
    }

    componentDidMount(){
        this.loadOrders();
    }

    render(){
        return (
            <Row>
                <Col xs="12" sm="12" lg="8">
                    {
                        this.state.loading ?
                            <div className="center">
                                <i className="icon icon-loading animated spin infinite f-20"> </i>
                            </div>
                            :
                            <div>

                                <div className="d-flex justify-content-between marg-b-15">
                                    <h2 className="ty-subtitle align-self-center">{
                                        "Vos commandes " +
                                        (this.props.orderStatus === "done" ? "passées" : "") +
                                        (this.props.orderStatus === "coming" ? "en cours" : "") +
                                        (this.props.orderStatus === "waiting" ? "en attente" : "")
                                    }
                                    </h2>
                                    <TYPagination
                                        page={this.state.page}
                                        total_pages={this.state.total_pages}
                                        onPageChanged={this.changePage}
                                    />
                                </div>
                                <OperationsOrdersTable
                                    orders={this.state.orders}
                                    onRemovedOrder={this.loadOrders}
                                    orderStatus={this.props.orderStatus}
                                    onNotify={this.onNotify}
                                />
                            </div>
                    }
                </Col>
            </Row>
        );
    }
}

OperationsOrders.defaultProps = {
    orderStatus: "done",
};

export default OperationsOrders;



// WEBPACK FOOTER //
// ./src/components/Operations/Orders.js